// import React, { useEffect, useState } from "react";
// import {
//   collection,
//   addDoc,
//   Timestamp,
//   getDocs,
//   doc,
//   updateDoc,
//   query,
//   where,
//   orderBy,
// } from "firebase/firestore";
// import { db } from "../firebase";
// import { useSelector } from "react-redux";
// import "../css/verification.css";

// const Verification = () => {
//   const currentTheme = useSelector((state) => state.theme.current);

//   const [data, setData] = useState({
//     details: "",
//     status: "pending",
//     booked: "",
//   });

//   const [verifications, setVerifications] = useState([]);
//   const [booked, setBooked] = useState("");
//   const [filtered, setFiltered] = useState([]);
//   const [pages, setPages] = useState(1);

//   let FormsPerPage = 3;
//   let noOfForms = verifications.length;
//   let totalForms = Math.ceil(noOfForms / FormsPerPage);
//   let start = (pages - 1) * FormsPerPage;
//   let pagination = verifications.slice(start, start + FormsPerPage);

//   const [selected, setSelected] = useState({
//     primary: "", // status
//     secondary: "", // bookedBy
//     sort: "desc", // default newest first
//     month: "", // month filter
//     year: "",
//   });

//   // ================= ADD VERIFICATION =================
//   const addVerification = async () => {
//     if (!data.details.trim()) return alert("Enter Details");

//     await addDoc(collection(db, "Verification"), {
//       date: Timestamp.now(),
//       details: data.details,
//       status: data.status || "pending",
//       bookedBy: data.booked || "",
//     });

//     setData({
//       details: "",
//       status: "pending",
//       booked: "",
//     });
//   };

//   // ================= UPDATE STATUS =================
//   const updateStatus = async (id, status) => {
//     try {
//       const docRef = doc(db, "Verification", id);
//       await updateDoc(docRef, { status });

//       setVerifications((prev) =>
//         prev.map((item) => (item.id === id ? { ...item, status } : item)),
//       );
//     } catch (error) {
//       alert("Operation not allowed for viewers");
//     }
//   };

//   // ================= UPDATE BOOKEDBY =================
//   const updateBookedBy = async (id, booked) => {
//     try {
//       const docRef = doc(db, "Verification", id);
//       await updateDoc(docRef, { bookedBy: booked });
//       setBooked(booked);
//     } catch (error) {
//       alert("Operation not allowed for viewers");
//     }
//   };

//   // ================= FETCH FILTERED DATA =================
//   useEffect(() => {
//     const fetchFilteredVerification = async () => {
//       const baseRef = collection(db, "Verification");
//       let conditions = [];

//       if (selected.primary) {
//         conditions.push(where("status", "==", selected.primary));
//       }

//       if (selected.secondary) {
//         conditions.push(where("bookedBy", "==", selected.secondary));
//       }

//       let q = query(
//         baseRef,
//         ...conditions,
//         orderBy("date", selected.sort === "asc" ? "asc" : "desc"),
//       );

//       const snapshot = await getDocs(q);

//       let data = snapshot.docs.map((doc) => ({
//         id: doc.id,
//         ...doc.data(),
//       }));

//       // Month filtering (client side because Firestore needs range query for month)
//       if (selected.month) {
//         data = data.filter((item) => {
//           const month = item.date?.toDate().toLocaleString("default", {
//             month: "long",
//           });
//           return month === selected.month;
//         });
//       }

//       if (selected.year) {
//         data = data.filter((item) => {
//           const year = item.date?.toDate().getFullYear();
//           return year.toString() === selected.year;
//         });
//       }
//       // let json = JSON.stringify(data);
//       // let parsed = JSON.parse(json);
//       // console.log(parsed[0].details.fullName);
      
//       setVerifications(data);
//     };

//     fetchFilteredVerification();
//   }, [selected, booked]);

//   // let json_verif = JSON.parse(verifications[0].details);
//   // console.log(JSON.parse(verifications));

//   return (
//     <div className="verification-container">
//       <h2>Verification</h2>

//       {/* ================= FILTERS ================= */}
//       <div className="filter-container">
//         {/* STATUS FILTER */}
//         <select
//           className="filter-select"
//           value={selected.primary}
//           onChange={(e) =>
//             setSelected((prev) => ({ ...prev, primary: e.target.value }))
//           }
//         >
//           <option value="">All Status</option>
//           <option value="pending">Pending</option>
//           <option value="done">Done</option>
//         </select>

//         {/* BOOKEDBY FILTER */}
//         <select
//           className="filter-select"
//           value={selected.secondary}
//           onChange={(e) =>
//             setSelected((prev) => ({ ...prev, secondary: e.target.value }))
//           }
//         >
//           <option value="">All BookedBy</option>
//           <option value="ahmad">Ahmad</option>
//           <option value="zain">Zain</option>
//           <option value="abbas mirza">Abbas Mirza</option>
//           <option value="ali mohammad">Ali Mohammad</option>
//           <option value="hussain">Hussain</option>
//           <option value="mahdi">Mahdi</option>
//           <option value="arsalan">Arsalan</option>
//           <option value="ali mehdi">Ali Mehdi</option>
//           <option value="ali abbas">Ali Abbas</option>
//         </select>

//         {/* SORT BY DATE */}
//         <select
//           className="filter-select"
//           value={selected.sort}
//           onChange={(e) =>
//             setSelected((prev) => ({ ...prev, sort: e.target.value }))
//           }
//         >
//           <option value="desc">Newest First</option>
//           <option value="asc">Oldest First</option>
//         </select>

//         {/* MONTH FILTER */}
//         <select
//           className="filter-select"
//           value={selected.month}
//           onChange={(e) =>
//             setSelected((prev) => ({ ...prev, month: e.target.value }))
//           }
//         >
//           <option value="">All Months</option>
//           {[
//             ...new Set(
//               verifications.map((v) =>
//                 v.date?.toDate().toLocaleString("default", { month: "long" }),
//               ),
//             ),
//           ].map((month) => (
//             <option key={month} value={month}>
//               {month}
//             </option>
//           ))}
//         </select>

//         <select
//           className="filter-select"
//           value={selected.year}
//           onChange={(e) =>
//             setSelected((prev) => ({ ...prev, year: e.target.value }))
//           }
//         >
//           <option value="">All Years</option>
//           {[
//             ...new Set(
//               verifications.map((v) => v.date?.toDate().getFullYear()),
//             ),
//           ].map((year) => (
//             <option key={year} value={year}>
//               {year}
//             </option>
//           ))}
//         </select>
//       </div>

//       <div className="total-form-count">
//         Total Forms: {verifications.length}
//       </div>

//       <div className="pagination">
//         <button disabled={pages === 1} onClick={() => setPages(pages - 1)}>
//           Prev
//         </button>
//         {(() => {
//           const pagess = [];
//           for (let i = 1; i <= totalForms; i++) {
//             pagess.push(
//               <button key={i} onClick={() => setPages(i)}>
//                 {i}
//               </button>,
//             );
//           }
//           return pagess;
//         })()}
//         <button
//           disabled={pages === totalForms}
//           onClick={() => setPages(pages + 1)}
//         >
//           Next
//         </button>
//       </div>

//       {/* ================= DISPLAY ================= */}
//       <div className="verification-card">
//         {pagination.map((verification) => (
//           <div
//             key={verification.id}
//             className="verification-content"
//             style={{
//               backgroundColor: currentTheme,
//               color:
//                 verification.status === "pending"
//                   ? "red"
//                   : verification.status === "done"
//                     ? "green"
//                     : "",
//             }}
//           >
//             <button
//               className="pending"
//               onClick={() => updateStatus(verification.id, "pending")}
//             >
//               Pending
//             </button>

//             <button
//               className="done"
//               onClick={() => updateStatus(verification.id, "done")}
//             >
//               Done
//             </button>

//             <p style={{ color: "white" }}>
//               Date: {verification.date?.toDate().toLocaleString()}
//             </p>

//             <p>Detail: {verification.details}</p>

//             <select
//               style={{ color: "white", background: "black" }}
//               value={verification.bookedBy || ""}
//               onChange={(e) => updateBookedBy(verification.id, e.target.value)}
//             >
//               <option value="">Choose</option>
//               <option value="ahmad">Ahmad</option>
//               <option value="zain">Zain</option>
//               <option value="abbas mirza">Abbas Mirza</option>
//               <option value="ali mohammad">Ali Mohammad</option>
//               <option value="hussain">Hussain</option>
//               <option value="mahdi">Mahdi</option>
//               <option value="arsalan">Arsalan</option>
//               <option value="ali mehdi">Ali Mehdi</option>
//               <option value="ali abbas">Ali Abbas</option>
//             </select>

//             <p style={{ color: "white" }}>Booked By: {verification.bookedBy}</p>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default Verification;





import React, { useEffect, useState } from "react";
import {
  collection, getDocs, doc, updateDoc, query, orderBy,
} from "firebase/firestore";
import { db } from "../firebase";
import { toast, ToastContainer } from "react-toastify";
import "../css/datapanel.css";

const STATUS_OPTIONS = ["pending","in-review","approved","rejected","done"];
const STATUS_COLORS  = {
  pending:"#f39c12","in-review":"#2980b9",
  approved:"#27ae60",rejected:"#e74c3c",done:"#27ae60",
};

const VOLUNTEERS = [
  "ahmad","zain","abbas mirza","ali mohammad","hussain",
  "mahdi","arsalan","ali mehdi","ali abbas",
];

const Verification = () => {
  const [records, setRecords]         = useState([]);
  const [loading, setLoading]         = useState(true);
  const [search, setSearch]           = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [sortOrder, setSortOrder]     = useState("desc");
  const [expanded, setExpanded]       = useState(null);

  useEffect(() => { fetchRecords(); }, [sortOrder]);

  const fetchRecords = async () => {
    setLoading(true);
    try {
      const q = query(collection(db, "Verification"), orderBy("date", sortOrder));
      const snap = await getDocs(q);
      setRecords(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (err) { toast.error("Failed to load verification records."); }
    setLoading(false);
  };

  const updateStatus = async (id, status) => {
    try {
      await updateDoc(doc(db, "Verification", id), { status });
      setRecords(prev => prev.map(r => r.id === id ? { ...r, status } : r));
      toast.success("Status updated.");
    } catch { toast.error("Update failed."); }
  };

  const updateBookedBy = async (id, value) => {
    try {
      await updateDoc(doc(db, "Verification", id), { bookedBy: value });
      setRecords(prev => prev.map(r => r.id === id ? { ...r, bookedBy: value } : r));
    } catch (err) { console.error(err); }
  };

  const filtered = records.filter(r => {
    if (statusFilter !== "all" && r.status !== statusFilter) return false;
    if (search) {
      const s = search.toLowerCase();
      const fd = r.formData || {};
      const name  = (fd.fullName || r.details || "").toString().toLowerCase();
      const phone = (fd.phoneNumber || "").toLowerCase();
      if (!name.includes(s) && !phone.includes(s)) return false;
    }
    return true;
  });

  const formatDate = ts => {
    if (!ts) return "—";
    const d = ts.toDate ? ts.toDate() : new Date(ts);
    return d.toLocaleDateString("en-IN", { day:"2-digit", month:"short", year:"numeric", hour:"2-digit", minute:"2-digit" });
  };

  return (
    <div className="dp-root">
      <ToastContainer />

      <div className="dp-header">
        <div className="dp-header-left">
          <span className="dp-header-icon">✅</span>
          <div>
            <h2 className="dp-title">Verification</h2>
            <p className="dp-subtitle">Verification queue for help requests and applicants</p>
          </div>
        </div>
        <button className="dp-refresh-btn" onClick={fetchRecords}>↻ Refresh</button>
      </div>

      {/* Stats */}
      <div className="dp-stats-row">
        <button
          className={`dp-stat-card ${statusFilter === "all" ? "dp-stat-active" : ""}`}
          style={{ "--sc":"#162f06" }}
          onClick={() => setStatusFilter("all")}
        >
          <span className="dp-stat-count">{records.length}</span>
          <span className="dp-stat-label">All</span>
        </button>
        {STATUS_OPTIONS.map(s => (
          <button
            key={s}
            className={`dp-stat-card ${statusFilter === s ? "dp-stat-active" : ""}`}
            style={{ "--sc": STATUS_COLORS[s] }}
            onClick={() => setStatusFilter(s)}
          >
            <span className="dp-stat-count">{records.filter(r => r.status === s).length}</span>
            <span className="dp-stat-label">{s.charAt(0).toUpperCase()+s.slice(1)}</span>
          </button>
        ))}
      </div>

      {/* Filters */}
      <div className="dp-filters">
        <input
          className="dp-search"
          placeholder="Search by name or phone…"
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        <select className="dp-select" value={sortOrder} onChange={e => setSortOrder(e.target.value)}>
          <option value="desc">Newest First</option>
          <option value="asc">Oldest First</option>
        </select>
        <span className="dp-count">{filtered.length} records</span>
      </div>

      {/* List */}
      {loading ? (
        <div className="dp-loading"><div className="dp-spinner" /><p>Loading…</p></div>
      ) : filtered.length === 0 ? (
        <div className="dp-empty"><span>📭</span><p>No verification records found.</p></div>
      ) : (
        <div className="dp-list">
          {filtered.map(rec => {
            const isOpen = expanded === rec.id;
            const fd = rec.formData || {};
            const name = fd.fullName || (typeof rec.details === "string" ? rec.details.slice(0,40) : "—");
            return (
              <div key={rec.id} className={`dp-card ${isOpen ? "dp-card-open" : ""}`}>
                <div className="dp-card-header" onClick={() => setExpanded(isOpen ? null : rec.id)}>
                  <div className="dp-card-left">
                    <span className="dp-status-pill" style={{ background: STATUS_COLORS[rec.status] || "#999" }}>
                      {rec.status || "pending"}
                    </span>
                    <span className="dp-card-name">{name}</span>
                    <span className="dp-card-sub">
                      {fd.phoneNumber || "—"} · {rec.helpType || "—"} · {formatDate(rec.date)}
                    </span>
                  </div>
                  <span className="dp-chevron">{isOpen ? "▲" : "▼"}</span>
                </div>

                {isOpen && (
                  <div className="dp-card-body">
                    {fd.fullName ? (
                      <div className="dp-info-grid">
                        <div className="dp-info-item"><span className="dp-info-key">Full Name</span><span className="dp-info-val">{fd.fullName}</span></div>
                        <div className="dp-info-item"><span className="dp-info-key">Phone</span><span className="dp-info-val">{fd.phoneNumber || "—"}</span></div>
                        <div className="dp-info-item"><span className="dp-info-key">Help Type</span><span className="dp-info-val" style={{textTransform:"capitalize"}}>{rec.helpType || "—"}</span></div>
                        <div className="dp-info-item"><span className="dp-info-key">Language</span><span className="dp-info-val">{rec.language || "—"}</span></div>
                        <div className="dp-info-item"><span className="dp-info-key">Occupation</span><span className="dp-info-val">{fd.occupation || "—"}</span></div>
                        <div className="dp-info-item"><span className="dp-info-key">Monthly Income</span><span className="dp-info-val">₹{fd.familyMonthlyIncome || "—"}</span></div>
                        <div className="dp-info-item"><span className="dp-info-key">Rent Status</span><span className="dp-info-val">{fd.rentStatus || "—"}</span></div>
                        <div className="dp-info-item"><span className="dp-info-key">Family Members</span><span className="dp-info-val">{fd.totalFamilyMembers || 0}</span></div>
                        <div className="dp-info-item dp-info-full"><span className="dp-info-key">Address</span><span className="dp-info-val">{fd.address || "—"}</span></div>
                        <div className="dp-info-item"><span className="dp-info-key">Date</span><span className="dp-info-val">{formatDate(rec.date)}</span></div>
                        <div className="dp-info-item"><span className="dp-info-key">Prev. Help Received</span><span className="dp-info-val">{fd.otherHelp || "—"}</span></div>
                      </div>
                    ) : (
                      <div className="dp-info-grid">
                        <div className="dp-info-item dp-info-full">
                          <span className="dp-info-key">Details</span>
                          <span className="dp-info-val" style={{whiteSpace:"pre-wrap"}}>
                            {typeof rec.details === "string" ? rec.details : JSON.stringify(rec.details, null, 2)}
                          </span>
                        </div>
                        <div className="dp-info-item"><span className="dp-info-key">Date</span><span className="dp-info-val">{formatDate(rec.date)}</span></div>
                      </div>
                    )}

                    <div className="dp-controls">
                      <div className="dp-ctrl-group">
                        <label className="dp-ctrl-label">Status</label>
                        <select className="dp-ctrl-select" value={rec.status || "pending"} onChange={e => updateStatus(rec.id, e.target.value)}>
                          {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s.charAt(0).toUpperCase()+s.slice(1)}</option>)}
                        </select>
                      </div>
                      <div className="dp-ctrl-group">
                        <label className="dp-ctrl-label">Assigned To</label>
                        <select className="dp-ctrl-select" value={rec.bookedBy || ""} onChange={e => updateBookedBy(rec.id, e.target.value)}>
                          <option value="">Choose volunteer</option>
                          {VOLUNTEERS.map(v => <option key={v} value={v}>{v.charAt(0).toUpperCase()+v.slice(1)}</option>)}
                        </select>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default Verification;